// @flow
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, type Middleware } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
// import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootSaga from 'saga';
import rootReducer from 'reducer';

import type { Store, State, Action } from './types';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const middleware: Array<Middleware<State, Action>> = [
  routerMiddleware(history),
  sagaMiddleware,
];
const store: Store = createStore(
  connectRouter(history)(rootReducer),
  composeWithDevTools(applyMiddleware(...middleware)),
);

sagaMiddleware.run(rootSaga);

export { history };
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js